import { useContext, useEffect } from 'react';

import { Approve } from '@/components/Approve/Approve';
import { Layout } from '@/components/Layout/Layout';
import { Main } from '@/components/Main/Main';
import { Section } from '@/components/Section/Section';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

/**
 * Address component
 * @returns {ReactElement}
 */
const ApprovePage = () => {
	const [, dispatch] = useContext(Context);

	useEffect(() => {
		void (async () => {
			const { setTitle } = await import('@/lib/util');
			setTitle('Bestätigung');
		})();

		dispatch({
			type: ActionTypes.setCurrentPage,
			payload: {
				key: 'currentPage',
				value: 'approvePage'
			}
		});

		dispatch({
			type: ActionTypes.showProductOnRight,
			payload: true
		});
	}, [dispatch]);

	return (
		<Layout className="layout-split">
			<Main>
				<Section className="section-approve">
					<Approve />
				</Section>
			</Main>
		</Layout>
	);
};

export default ApprovePage;
